"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const euclid_1 = require("@reality/euclid");
class ClientAnimationManager {
    constructor() {
        this.animationMap = new Map();
    }
    queueAnimation(instance, animationID) {
        var _a;
        // FIXME types
        const animation = ((_a = instance.baseManifest.states) === null || _a === void 0 ? void 0 : _a[instance.entityState.viewState].animations[animationID]) ||
            instance.baseManifest.animations[animationID];
        if (animation) {
            this.animationMap.set(instance.instanceID, {
                start: Date.now(),
                animation,
            });
        }
        else {
            throw Error(`Attempted to queue animation ${animationID} for ${instance.instanceID} in state ${instance.entityState.viewState} which does not exist`);
        }
    }
    getAnimationLayers(instanceID) {
        // TODO: support Entity level animations
        if (this.animationMap.has(instanceID)) {
            const instance = this.animationMap.get(instanceID);
            const animation = instance.animation;
            const frame = Math.round(((Date.now() - instance.start) / animation.length) * animation.frames.length);
            if (frame < animation.frames.length) {
                return animation.frames[frame];
            }
            else {
                // this animation has expired, let's do some cleanup
                this.animationMap.delete(instanceID);
            }
        }
        return null;
    }
    getAnimationDisplacement(instanceID) {
        var _a, _b;
        const instance = this.animationMap.get(instanceID);
        if (instance && instance.animation.startingDisplacement) {
            const startingDisplacement = instance.animation.startingDisplacement;
            const endingDisplacement = (_b = (_a = instance.animation) === null || _a === void 0 ? void 0 : _a.endingDisplacement) !== null && _b !== void 0 ? _b : euclid_1.ORIGIN;
            const totalDisplacement = euclid_1.CoordinateUtils.subtract(endingDisplacement, startingDisplacement);
            const scale = (Date.now() - instance.start) / instance.animation.length;
            const scaledDisplacement = euclid_1.CoordinateUtils.scale(totalDisplacement, scale);
            return euclid_1.CoordinateUtils.add(startingDisplacement, scaledDisplacement);
        }
        return euclid_1.ORIGIN;
    }
}
exports.default = ClientAnimationManager;
//# sourceMappingURL=ClientAnimationManager.js.map